import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    Button,
    Box,
} from '@mui/material';
import { useAppSelector } from '../../redux-store/hooks';

interface PropSelectorDialogProps {
    open: boolean;
    onClose: () => void;
    onSelect: (propUrl: string) => void;
}

const PropSelectorDialog: React.FC<PropSelectorDialogProps> = ({
    open,
    onClose,
    onSelect,
}) => {
    const allProps = useAppSelector((state) => state.props.props);
    const [selectedProp, setSelectedProp] = useState<any>(null);

    const handleSelect = () => {
        if (selectedProp) {
            onSelect(selectedProp.propUrl);
            setSelectedProp(null);
            onClose();
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Select a Prop</DialogTitle>

            <DialogContent>
                <Grid container spacing={2}>
                    {allProps.map((prop, index) => (
                        <Grid
                            item
                            key={index}
                            xs={4}
                            onClick={() => setSelectedProp(prop)}
                            sx={{
                                border:
                                    selectedProp?.propName === prop.propName
                                        ? '2px solid #3f51b5'
                                        : '1px solid #ccc',
                                borderRadius: '8px',
                                p: 0.5,
                                cursor: 'pointer',
                                textAlign: 'center',
                            }}
                        >
                            <Box
                                component="img"
                                src={prop.propUrl}
                                alt={prop.propName}
                                width={60}
                                height={60}
                                sx={{ objectFit: 'contain' }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    variant="contained"
                    disabled={!selectedProp}
                    onClick={handleSelect}
                >
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export { PropSelectorDialog };
